import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderForwardRelatedCargoTaxi from "./billings-order-forward-related-cargo-taxi";
import BillingsOrderForwardRelatedCargoTaxiParams from "./billings-order-forward-related-cargo-taxi-params";

const useBillingsOrderForwardRelatedCargoTaxi = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderForwardRelatedCargoTaxi>({
      data: [],
    });

  const load = async (
    params: BillingsOrderForwardRelatedCargoTaxiParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoTaxi =
        await billingService.getOrderForwardRelatedCargoTaxiBillings(
          params,
          signal,
        );

      setData(cargoTaxi);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderForwardRelatedCargoTaxi;
